<template>
  <div class="container">
    <div class="q-mt-xl">
      <div class="q-my-lg">
        <div>
          <p></p>
          <q-btn
            label="Criar Novo"
            no-caps
            class="btn"
            icon="add"
            color="positive"
            @click="rightDrawerOpen = true"
          />
        </div>
      </div>
      <div class="q-mt-xl">
        <div class="row col-12 justify-between items-center q-mb-sm">
          <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
            Checklists Criados
          </div>
          <div class="row col-md-3 col-xs-12 justify-end">
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              type="text"
              class="col-md col-xs-7 input"
              placeholder="Pesquisar"
              v-model="filtro.nome"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </div>
        <q-linear-progress v-if="loading" indeterminate size="3px" />
        <q-table
          :columns="columns"
          :rows="listaChecklist"
          :hide-bottom="!listaChecklist.length == 0"
          no-data-label="Nenhum checklist criado."
          v-model:selected="selected"
          dense
          selection="single"
          class="my-sticky-dynamic"
          flat
          :class="{ 'my-sticky-dynamic': !mobile }"
          :grid="mobile"
          :rows-per-page-options="[0]"
          row-key="checkListUuid"
        >
          <template v-slot:item="props">
            <div class="q-pa-xs row col-12">
              <q-card class="container-grid-table col-12">
                <div class="q-pa-sm">
                  <div class="row col-12 items-center">
                    <div class="col-7">
                      <div
                        style="word-break: break-all"
                        class="row col-12 items-center"
                      >
                        <strong class="q-mr-xs">Nome:</strong>
                        <span v-if="!props.selected">
                          {{ props.row.nome }}</span
                        >
                        <input
                          v-else
                          v-model="props.row.nome"
                          dense
                          class="input-mobile"
                          outlined
                        />
                      </div>
                    </div>
                    <div class="col">
                      <div class="row col-12 justify-end">
                        <div>
                          <q-btn
                            v-if="!props.selected"
                            icon="edit"
                            flat
                            color="primary"
                            :disable="disable"
                            @click="
                              (props.selected = true),
                                (dadoEditarChecklist = { ...props.row })
                            "
                          />
                          <q-btn
                            v-else
                            icon="done"
                            flat
                            round
                            color="positive"
                            :disable="disable"
                            @click="editarChecklist(props.row)"
                          />
                        </div>
                        <div>
                          <q-btn
                            icon="delete"
                            flat
                            color="red"
                            :disable="disable"
                            @click="excluirChecklist(props.row.checkListUuid)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </q-card>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th
                class="text-weight-bolder"
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td
                ><span v-if="!props.selected"> {{ props.row.nome }}</span>
                <q-input
                  v-else
                  class="input"
                  dense
                  outlined
                  v-model="props.row.nome"
              /></q-td>
              <q-td class="coluna-btn">
                <q-btn
                  v-if="!props.selected"
                  icon="edit"
                  flat
                  round
                  :disable="disable"
                  color="primary"
                  @click="
                    (props.selected = true),
                      (dadoEditarChecklist = { ...props.row })
                  "
                />
                <q-btn
                  v-else
                  icon="done"
                  flat
                  round
                  :disable="disable"
                  color="positive"
                  @click="editarChecklist(props.row)"
                />
              </q-td>
              <q-td class="coluna-btn">
                <q-btn
                  icon="delete"
                  flat
                  round
                  :disable="disable"
                  color="red"
                  @click="excluirChecklist(props.row.checkListUuid)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div
          v-if="listaChecklist.length > 0"
          class="row justify-center q-mt-md"
        >
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            :size="mobile ? 'md' : 'sm'"
          />
        </div>
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="rightDrawerOpen = false"
              />
              <span class="texto-titulo-modal"> Criar Checklist </span>
            </div>
          </div>
          <div style="width: 100%; height: 89%">
            <div class="column col-12 justify-between no-wrap container-modal">
              <div class="q-px-md text-weight-bold">
                <div>
                  <div class="texto-titulo-input">Nome</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoCriarChecklist.nome"
                    dense
                    :rules="[validacaoCaracteresChecklist]"
                    hide-bottom-space
                    outlined
                    maxlength="255"
                  />
                </div>
              </div>
              <div class="q-my-sm q-px-md">
                <q-btn
                  label="Criar"
                  color="positive"
                  no-caps
                  icon="done"
                  @click="criarChecklist()"
                />
              </div>
            </div>
          </div>
        </q-card>
      </Transition>
    </div>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    let rightDrawerOpen = ref(false);
    const catalogoUuid = salvarCatalogoUuid();
    const listaChecklist = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const dadoCriarChecklist = ref({
      nome: "",
      descricao: "",
    });
    const dadoEditarChecklist = ref({});
    let disable = ref(false);
    const filtro = ref({ nome: "" });
    const selected = ref([]);
    let loading = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarChecklist = async (page = 0, rowsNumber = 15) => {
      if (catalogoUuid.catalogoUuid.value === null) {
        listaChecklist.value = [];
        return;
      }
      disable.value = true;
      loading.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarChecklist", {
          catalogoUuid: catalogoUuid.catalogoUuid.value,
          nome: filtro.value.nome,
          page: page,
          perPage: rowsNumber,
        });
        listaChecklist.value = response.data.resultado.dados;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        loading.value = false;
      }
    };

    const criarChecklist = async () => {
      if (validacaoCaracteresChecklist(dadoCriarChecklist.value.nome) != true) {
        return;
      }
      if (dadoCriarChecklist.value.nome === "") {
        quasar.notify({
          message: "O nome é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("ferramentaria/adicionarChecklist", {
          nome: dadoCriarChecklist.value.nome,
          descricao: dadoCriarChecklist.value.nome,
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
          catalogoUuid: catalogoUuid.catalogoUuid.value,
        });
        listarChecklist();
        quasar.notify({
          message: "Checklist criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        resetVariaveis();
        rightDrawerOpen.value = false;
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const validacaoCaracteresChecklist = (val) => {
      const regex = /^[a-zA-ZÀ-ÖØ-öØ-ÿ?Çç\s]*$/;

      if (!regex.test(val)) {
        return "Caracteres especiais não são permitidos.";
      } else {
        return true;
      }
    };

    const excluirChecklist = async (uuid) => {
      try {
        await store.dispatch("ferramentaria/excluirChecklist", {
          checkListUuid: uuid,
        });
        quasar.notify({
          message: "Checklist deletado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarChecklist();
        selected.value = [];
      } catch (error) {
        quasar.notify({
          message: error.response?.data?.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarChecklist = async (dado) => {
      if (dadoEditarChecklist.value.nome === dado.nome) {
        selected.value = [];
        return;
      }
      if (validacaoCaracteresChecklist(dado.nome) != true) {
        return;
      }
      try {
        await store.dispatch("ferramentaria/editarChecklist", {
          checkListUuid: dado.checkListUuid,
          nome: dado.nome,
          descricao: dado.nome,
        });
        listarChecklist();
        quasar.notify({
          message: "Checklist editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        selected.value = [];
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetVariaveis = () => {
      dadoCriarChecklist.value = {
        nome: "",
        descricao: "",
      };
    };

    watch(
      () => pagination.value.page,
      () => {
        listarChecklist(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => filtro.value.nome,
      () => {
        listarChecklist();
      }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value == false) {
          selected.value = [];
        }
      }
    );

    watch(
      () => catalogoUuid.catalogoUuid.value,
      () => {
        listarChecklist();
      }
    );

    onMounted(() => {
      listarChecklist();
    });

    return {
      columns,
      rightDrawerOpen,
      listarChecklist,
      listaChecklist,
      criarChecklist,
      resetVariaveis,
      excluirChecklist,
      editarChecklist,
      validacaoCaracteresChecklist,
      dadoEditarChecklist,
      catalogoUuid,
      pagination,
      disable,
      filtro,
      selected,
      dadoCriarChecklist,
      mobile,
      loading,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.container {
  height: 100% !important;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-modal {
  height: 100%;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.texto-titulo-modal {
  font-size: 16px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.titulo-tabela {
  font-size: 18px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .btn {
    font-size: 12px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .input-mobile {
    width: 90px;
    outline: none;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .input-modal {
    font-size: 12px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
}
@media (max-width: 372px) {
  .btn {
    font-size: 11px;
  }
}
</style>
